export default "__VITE_ASSET__CZX4734Z__"